import { useEffect, useState } from 'react';
import { CollectionKey } from '~/assets/collections';
import { playSound, Sound } from '~/assets/sounds';
import { CurrencyIcon } from '~/components/collections';
import { CollectionImage } from '~/components/collections/CollectionImage';
import { useWalletIcon } from '~/hooks';
import { WalletType, walletTypeCurrency } from '~/shared';
import { Text } from '../Text';
import {
	shopItemProductImageSize,
	ShopItemProductVariant,
} from './ShopItemProduct.model';
import {
	StyledContainer,
	StyledImageContainer,
	StyledNewDot,
	StyledNewShadow,
	StyledPrice,
	StyledPriceContainer,
	StyledPriceLabel,
	StyledTopContainer,
} from './ShopItemProduct.styled';

export interface IShopItemProductProps {
	itemId: string;
	collection: CollectionKey;
	name: string;
	price: number;
	walletType: WalletType;
	isNew?: boolean;
	selected?: boolean;
	level?: number;
	modalBuyName?: string;
	variant?: ShopItemProductVariant;
	priceLabel?: string;
	trackerKey?: string;
	trackerIsUnseen?: (key: string) => boolean;
	trackerMarkSeen?: (key: string) => void;
}

const ShopItemProduct = ({
	itemId,
	collection,
	name,
	price,
	walletType,
	selected,
	level,
	variant = ShopItemProductVariant.Default,
	priceLabel,
	trackerKey,
	onClick,
	trackerIsUnseen,
	trackerMarkSeen,
	...props
}: IShopItemProductProps & React.HTMLAttributes<HTMLDivElement>) => {
	const currencyIcon = useWalletIcon(walletTypeCurrency[walletType], true);
	const [isUnseen, setIsUnseen] = useState(trackerIsUnseen?.(trackerKey ?? ''));

	useEffect(() => {
		if (selected && trackerKey) {
			trackerMarkSeen?.(trackerKey);
			setIsUnseen(false);
		}
	}, [selected, trackerKey]);

	return (
		<StyledContainer
			$walletType={walletType}
			$selected={selected}
			$variant={variant}
			{...props}
			onMouseEnter={() => playSound(Sound.LinkCursor)}
			onClick={(e) => {
				onClick?.(e);
				playSound(Sound.ClickButton);
			}}
		>
			<StyledTopContainer>
				<Text>
					{name} {level && <span>({level} ур.)</span>}
				</Text>
				{isUnseen && trackerKey && (
					<StyledNewDot>
						<StyledNewShadow />
					</StyledNewDot>
				)}
			</StyledTopContainer>
			<StyledImageContainer $variant={variant}>
				<CollectionImage
					collection={collection}
					id={itemId}
					size={shopItemProductImageSize[variant]}
				/>
			</StyledImageContainer>
			<StyledPriceContainer $variant={variant}>
				{priceLabel && <StyledPriceLabel>{priceLabel}</StyledPriceLabel>}
				<StyledPrice>
					<Text>{price.toLocaleString('ru-RU')}</Text>
					<CurrencyIcon icon={currencyIcon} size="md" />
				</StyledPrice>
			</StyledPriceContainer>
		</StyledContainer>
	);
};

export { ShopItemProduct };
